module.exports = __webpack_public_path__ + "resources/f0d74efcb3514ddd8b40798b589948d1.otf";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/CompactaBT-Bold.otf
// module id = 240
// module chunks = 0